"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyAttributePlatformName = void 0;
var StrategyAttributePlatformName;
(function (StrategyAttributePlatformName) {
    StrategyAttributePlatformName["Linux"] = "linux";
    StrategyAttributePlatformName["Windows"] = "windows";
    StrategyAttributePlatformName["Macos"] = "macos";
    StrategyAttributePlatformName["Android"] = "android";
    StrategyAttributePlatformName["Ios"] = "ios";
})(StrategyAttributePlatformName = exports.StrategyAttributePlatformName || (exports.StrategyAttributePlatformName = {}));
//# sourceMappingURL=strategy-attribute-platform-name.js.map